import React, { useEffect, useMemo, useState } from "react";
import { useAuth } from "../auth/AuthContext";
import { useRole } from "../auth/useRole";
import CreateScenathon from "../components/CreateScenathon";
import ScenathonList from "../components/ScenathonList";
// import TasksAdmin from "./TasksAdmin"; // ✅ REMOVIDO: tasktodo table no longer exists
import CountryLabelsAdmin from "./CountryLabelsAdmin";
// import PathwaysScenariosAdmin from "./PathwaysScenariosAdmin"; // ✅ REMOVIDO
// import ScenathonProcessMonitor from "./ScenathonProcessMonitor"; // ✅ REMOVIDO
import GameslogAdmin from "./GameslogAdmin";
import DefinedScenariosAdmin from "./DefinedScenariosAdmin";
// import TradeoffIndicatorsAdmin from "./TradeoffIndicatorsAdmin"; // ✅ REMOVIDO
import Usuarios from "./Usuarios";

const ADMIN_SCENATHON_TAB_KEY = "admin_scenathon_active_tab_v1";
const ALLOWED_TABS = new Set([
  "list",
  "create",
  // "tasks", // ✅ REMOVIDO: tasktodo table no longer exists
  "country-labels",
  // "data", // ✅ REMOVIDO: Pathways & scenarios
  // "process", // ✅ REMOVIDO
  "gameslog",
  "definedscenarios",
  // "tradeoff-indicators", // ✅ REMOVIDO
  "users",
]);

const TabButton = ({ label, isActive, onClick }) => (
  <button
    onClick={onClick}
    className={`px-6 py-3 font-medium text-sm border-b-2 transition whitespace-nowrap ${
      isActive
        ? "border-green-600 text-green-600"
        : "border-transparent text-gray-600 hover:text-gray-900"
    }`}
  >
    {label}
  </button>
);

export default function AdminScenathon() {
  const { hasAccessToSection, SECTIONS } = useRole();
  const [activeTab, setActiveTab] = useState(() => {
    try {
      const saved = localStorage.getItem(ADMIN_SCENATHON_TAB_KEY);
      return saved && ALLOWED_TABS.has(saved) ? saved : "list";
    } catch {
      return "list";
    }
  });

  useEffect(() => {
    try {
      localStorage.setItem(ADMIN_SCENATHON_TAB_KEY, activeTab);
    } catch {
      // ignore storage errors
    }
  }, [activeTab]);

  const tabConfig = useMemo(
    () => [
      {
        key: "list",
        label: "Scenathons",
        section: SECTIONS.ADMIN_SCENATHON_LIST,
      },
      {
        key: "create",
        label: "Create new",
        section: SECTIONS.ADMIN_SCENATHON_CREATE,
      },
      // ✅ REMOVIDO: Tasks tab - tasktodo table no longer exists
      {
        key: "country-labels",
        label: "Country labels",
        section: SECTIONS.ADMIN_SCENATHON_COUNTRY_LABELS,
      },
      // ✅ REMOVIDO: Pathways & scenarios - data
      // ✅ REMOVIDO: Process tab
      {
        key: "gameslog",
        label: "Games log",
        section: SECTIONS.ADMIN_SCENATHON_GAMESLOG,
      },
      {
        key: "definedscenarios",
        label: "Defined scenarios",
        section: SECTIONS.ADMIN_SCENATHON_DEFINEDSCENARIOS,
      },
      // ✅ REMOVIDO: Targets tab
      // ✅ REMOVIDO: Tradeoff indicators
      {
        key: "users",
        label: "Users",
        section: SECTIONS.ADMIN_SCENATHON_USERS,
      },
    ],
    [SECTIONS],
  );

  const visibleTabs = useMemo(
    () => tabConfig.filter((tab) => hasAccessToSection(tab.section)),
    [hasAccessToSection, tabConfig],
  );

  useEffect(() => {
    if (visibleTabs.length === 0) return;
    const isCurrentVisible = visibleTabs.some((tab) => tab.key === activeTab);
    if (!isCurrentVisible) {
      setActiveTab(visibleTabs[0].key);
    }
  }, [activeTab, visibleTabs]);

  if (!hasAccessToSection(SECTIONS.ADMIN_SCENATHON)) {
    return (
      <div className="w-full p-6 font-montserrat">
        <div className="max-w-2xl mx-auto">
          <div className="bg-red-50 border border-red-200 rounded-lg p-6">
            <h2 className="text-red-800 font-bold text-lg mb-2">Access Denied</h2>
            <p className="text-red-700">
              You do not have access to Admin Scenathon for your current user type.
            </p>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="w-full font-montserrat">
      <div className="rounded-3xl border border-slate-200 bg-white p-2 shadow-sm mb-6 mt-8">
        <div className="flex flex-wrap gap-3">
          {visibleTabs.map((tab) => (
            <button
              key={tab.key}
              type="button"
              onClick={() => setActiveTab(tab.key)}
              className={`rounded-2xl border px-4 py-3 text-sm font-medium transition ${
                activeTab === tab.key
                  ? "border-green-600 bg-green-50 text-green-700 shadow-sm"
                  : "border-transparent bg-slate-50 text-slate-700 hover:border-slate-300 hover:bg-slate-100"
              }`}
            >
              {tab.label}
            </button>
          ))}
        </div>
      </div>

      <main className="space-y-6">
        {visibleTabs.length === 0 ? (
          <div className="rounded-3xl border border-amber-200 bg-amber-50 p-6 text-amber-900">
            No Admin Scenathon sections are enabled for this user type.
          </div>
        ) : (
          <div className="rounded-3xl border border-slate-200 bg-white p-6 shadow-sm">
            {activeTab === "list" && <ScenathonList standalone={false} />}
            {activeTab === "create" && (
              <CreateScenathon standalone={false} onScenathonCreated={() => setActiveTab("list")} />
            )}
            {/* ✅ REMOVIDO: TasksAdmin - tasktodo table no longer exists */}
            {activeTab === "country-labels" && <CountryLabelsAdmin />}
            {/* ✅ REMOVIDO: PathwaysScenariosAdmin */}
            {/* ✅ REMOVIDO: ScenathonProcessMonitor */}
            {activeTab === "gameslog" && <GameslogAdmin />}
            {activeTab === "definedscenarios" && <DefinedScenariosAdmin />}
            {/* ✅ REMOVIDO: TargetsAdmin */}
            {/* ✅ REMOVIDO: TradeoffIndicatorsAdmin */}
            {activeTab === "users" && <Usuarios />}
          </div>
        )}
      </main>
    </div>
  );
}
